import { EventEmitter, Injectable } from '@angular/core';
import {IDisplayInfo} from '../shared/models/models';

@Injectable()
export class CardBackgroundUpdateService {
    public static $name = 'cardBackgroundUpdateService';
    public backgroundChangeEvent = new EventEmitter<any>();
    public modelHasSensorWithId(displayInfo: IDisplayInfo, sensorId: number) {
        return !!displayInfo.dataViewModel.find((data) => {
            return data.sensorId && data.sensorId === sensorId;
        });
    }
}
